import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { log } from './app/utils/logging';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

declare global {
  interface Window {
    uiLoggerConfigs?: any;
    uiLoggerSdk?: any;
    errorObj?: any;
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => log.error(``, err));
